import type * as React from "react";
import { UserProvider } from "@/stores/CurrentUser.tsx";
import { useIsLoggedIn } from "@/stores/LoggedInStatus.ts";
import { Logo } from "./Logo.tsx";
import { Navigation } from "./Navigation.tsx";
import { container, mainNav } from "./index.css.ts";

export { headerHeight } from "./index.css.ts";

export const Header: React.FC = () => {
  const isLoggedIn = useIsLoggedIn();

  return (
    <header className={mainNav}>
      <div className={container}>
        <Logo />
        {isLoggedIn && (
          <UserProvider>
            <Navigation />
          </UserProvider>
        )}
      </div>
    </header>
  );
};
